import { render, staticRenderFns } from "./ChiefDeptSuperAdminPreSelect.vue?vue&type=template&id=036290a4"
import script from "./ChiefDeptSuperAdminPreSelect.vue?vue&type=script&lang=js"
export * from "./ChiefDeptSuperAdminPreSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports